import { useEffect, useMemo } from 'react'
import { BUTTON_SIZE, BUTTON_TYPE, Button, styled } from '~/app/components'
import BottomSheet from '~/app/components/common/BottomSheet/BottomSheet'
import useModalHash from '~/app/components/common/useModalHash'
import { toKRW } from '~/app/utils/krNumberToString'
import { Typography } from '@yanolja-rnd/ya-com-core'

const Content = styled.div`
  margin: 0 auto 0.8rem;
  padding: 0 2rem;
  max-width: 40rem;
  width: 100%;
`
const PriceDiscount = styled.div`
  padding: 1.6rem 2rem;
  background: ${({ theme }) => theme.color.yaorange50};
  ${Typography('subtitle3.multiline').bold};
  border: 0.1rem solid ${({ theme }) => theme.color.yaorange200};
  border-radius: 0.4rem;
  text-align: center;
`
const Pink = styled.span`
  color: ${({ theme }) => theme.color.blue600};
`

interface IUseVipBottomSheet {
  discountPrice: number
  onOrder: () => void
  onImpressed: () => void
}

export const VipDiscountBottomSheet = ({
  isOpen,
  discountPrice,
  onOrder,
  onClose,
  onImpressed,
}: {
  isOpen: boolean
  discountPrice: number
  onOrder: () => void
  onClose: () => void
  onImpressed: () => void
}) => {
  useEffect(() => {
    isOpen && onImpressed()
  }, [isOpen])

  return (
    <BottomSheet
      isOpened={isOpen}
      title=""
      buttons={
        <Button
          type={BUTTON_TYPE.PRIMARY}
          size={BUTTON_SIZE.XL}
          title={'계속 구매하기'}
          isFullSize
          onClick={onOrder}
        />
      }
      onRequestClose={onClose}
      onBackgroundClick={onClose}
    >
      <Content>
        <PriceDiscount>
          Gold Class 혜택이 적용되어
          <br />
          <Pink>{toKRW(discountPrice)}</Pink> 더 할인받았어요!
        </PriceDiscount>
      </Content>
    </BottomSheet>
  )
}

/**
 * 회원 등급 검증시 VIP 승급된 경우 노출되는 가격 인하 안내 바텀시트
 */
const useVipBottomSheet = ({ discountPrice, onOrder, onImpressed }: IUseVipBottomSheet) => {
  const [isOpenVipBottomSheet, setIsOpenVipBottomSheet] = useModalHash({ id: 'vipBottomSheet' })

  const onClose = () => setIsOpenVipBottomSheet(false)

  const vipBottomSheet = useMemo(
    () => (
      <VipDiscountBottomSheet
        discountPrice={discountPrice}
        onOrder={onOrder}
        isOpen={isOpenVipBottomSheet}
        onClose={onClose}
        onImpressed={onImpressed}
      />
    ),
    [isOpenVipBottomSheet, discountPrice, onOrder, onImpressed]
  )

  return {
    vipBottomSheet,
    setIsOpenVipBottomSheet,
  }
}

export default useVipBottomSheet
